var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"framean",staticClass:"item-framean",style:(_vm.styles)},[_c('div',{staticClass:"content",style:(_vm.contentStyles)},_vm._l((_vm.detail.banner),function(item,index){return _c('img',{key:index,attrs:{"src":item.pic,"alt":""}})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }